export default __webpack_public_path__ + "static/media/protein.b493539c.png";